import React from 'react';
import {Card} from './card';
import assurance from './../../../../../assets/images/svg/100-assurance.svg';
import {BankAccountType} from '../../../../../constants/models/servicePayloads/bankAccountType';

export const Assurance = ({branch, isMain, globalPayload, setGlobalPayload}) => {
    const cardTypes = [BankAccountType.AssuranceDeces, BankAccountType.AssuranceObseque, BankAccountType.AssuranceVie];

    return (
        <div className="grid grid-md-min grid-lg-tight grid-lg-4">
            {
                cardTypes.map((name, index) => {
                    return <Card key={index} cardType={name} icon={assurance} branch={branch} isMain={isMain}  globalPayload={globalPayload} setGlobalPayload={setGlobalPayload}/>
                })
            }
            {/* <PasService icon={assurance} cardType={BankAccountType.PasAssurance}/> */}
        </div>
    );
}